export default __webpack_public_path__ + "static/media/gd.d1128053.svg";